import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { userInfoAtom } from '~atoms';
import { SkcDeviceGroupsOverviewContainer } from '~features/access';

import Page from '../page';

const SkcDeviceGroupsPage = () => {
	const { t } = useTranslation();

	const [userInfo] = useAtom(userInfoAtom);

	return (
		<Page title={t('deviceGroups')}>
			<SkcDeviceGroupsOverviewContainer />
		</Page>
	);
};

export default SkcDeviceGroupsPage;
